module.exports = __webpack_public_path__ + "img/power.ec86fcd1.png";